// @ts-nocheck
/* eslint-disable */
import Content from './content';
import { TYPES_TRAIN, typeIdToType } from './transportlines';
import { addListener, removeListeners } from "~/lib/signals";
import { CONFIG } from "~/config";
import Scene from "~/scene";
import { store } from '~/state/store';
import { getSignIcon } from "~/util/pt-signs";

/**
 * @class Rozklada zastavku na oznacniky (balonky)
 * @augments Content
 * @private
 */
export default class Signs extends Content {
	constructor(data, options) {
		super(data, options);
		const { zoom } = store.getState().map;

		this._mapy = Mapy;
		this._zoom = zoom;
		this._sc = [];
		this._highlights = [];
		this._type = null;
		this._marker = null;
		this._ss = [];
		this._ss.push(Scene.addListener("markers-ready", "_setSigns", this));

		this._sc.push(addListener(this, "detail-activated", "_setSigns"));
		this._sc.push(addListener(this, "detail-deactivated", "_clearHighlights"));
		this._sc.push(addListener(this, "request-sign-type", "_requestType"));
		this._sc.push(addListener(this, "line-sign-highlight", "_highlightSignId"));
	}

	destroy() {
		removeListeners(this._sc);
		this._clearHighlights(true);
		if (this._marker) {
			Mapy.getComponent("masakovac").removeMarker(this._marker);
			this._marker.destroy();
			this._marker = null;
		}
		Scene.removeListeners(this._ss);

		if (CONFIG.inFrame) {
			Scene.removeListeners([this._mcSignal]);
		}

		super.destroy();
	}

	_build() {
		this._markers = [];

		for (var i = 0; i < this._data.length; i++) {
			var coords = Scene.coordsFromWGS84(this._data[i].mark.x, this._data[i].mark.y);

			var r = getSignIcon(this._data[i].typeId);
			var marker = Scene.createMarkerMapyWindy(coords, undefined, {
				type: Scene.VISUAL.MARKER_WINDY.SMALL,
				icon: r.icon,
				srcset: r.srcset
			});
			marker.setPOI(Object.assign({ source: "pubt" }, this._data[i]));
			marker.setActive(false);
			this._markers.push(marker);
		}

		if (CONFIG.inFrame) {
			this._mcSignal = Scene.addListener("marker-click", "_markerClick", this);
		}
	}

	_setSigns() {
		var masakovac = Mapy.getComponent("masakovac");
		var markers = masakovac.getMarkers();
		const state = store.getState();
		const { data: detailData } = state.detail;
		const { zoom } = state.map;

		if (zoom >= 17
			&& TYPES_TRAIN.indexOf(parseInt(detailData?.typeId)) == -1) { // pokud se jedna o vlak, nezobrazujeme oznacniky
			this._clearHighlights();
			if (this._marker) {
				masakovac.removeMarker(this._marker, !this._markers.length);
			}

			for (var i = 0; i < this._markers.length; i++) {
				var id = this._markers[i].getPlainId();
				var source = this._markers[i].getSource();
				var options = {};
				var typeId = this._data[i].typeId;
				var coords = Scene.coordsFromWGS84(this._data[i].mark.x, this._data[i].mark.y);
				var r = getSignIcon(this._data[i].typeId);
				var opts = {
					type: Scene.VISUAL.MARKER_WINDY.SMALL,
					icon: r.icon,
					srcset: r.srcset
				};
				var d = false;

				if (this._data.length == 1) { // je to jediny oznacnik dane zastavky
					d = true;
				}
				else if (typeId && this._type && this._type == typeIdToType(typeId)) {
					opts.type = Scene.VISUAL.MARKER_WINDY.MIDDLE;
					d = this._options.id.indexOf(id) > -1;
				}
				else if (this._options.id.indexOf(id) > -1) {
					d = true;
				}

				var marker = Scene.createMarkerMapyWindy(coords, undefined, opts);
				marker.setPOI(Object.assign({ source: "pubt" }, this._data[i]));
				marker.setActive(d);
				this._swapMarkers(i, marker, markers);

				this._highlights.push(this._markers[i]);
				masakovac.addMarker("detail", this._markers[i], source, id, true);
			}

			if (this._highlights.length) {
				Mapy.getComponent("detail").setMarkerVisibility(false);

				if (!Mapy.getComponent("detail").getMarker().append) {
					masakovac.redraw();
				}
			}
		} else {
			while (this._highlights.length) {
				masakovac.removeMarker(this._highlights.shift(), true);
			}

			if ([6007,6008].indexOf(parseInt(detailData?.typeId)) > -1 && detailData?.extend.station) { // pokud se jedna o oznacnik vlakove zastavky vlozime do mapy marker s id vlakove zastavky
				if (!this._marker) {
					this._marker = Scene.createMarkerMapyWindyDetailFromPOI(detailData, undefined, { fromMarker: Mapy.getComponent("detail").getFromMarker(), best: Mapy.getComponent("detail").getGalleryData().best }); // Mapy.MarkerDetail.fromPOI
				}
				masakovac.addMarker("detail", this._marker, detailData?.source, parseInt(detailData?.extend.station));
			}
			else {
				Mapy.getComponent("detail").setMarkerVisibility(true);
			}
		}
	}

	_clearHighlights(redraw) {
		while (this._highlights.length) {
			Mapy.getComponent("masakovac").removeMarker(this._highlights.shift(), true);
		}

		if (redraw) {
			Mapy.getComponent("masakovac").redraw();
		}
	}

	_requestType(e) {
		this._type = e.data.type;
		if (e.data.id) {
			this._type = null;
			this._options.id = e.data.id;
		}
		this._setSigns();
	}

	_highlightSignId(e) {
		var masakovac = Mapy.getComponent("masakovac");
		var data = e.data;
		var markers = masakovac.getMarkers();
		for (var i = 0; i < this._markers.length; i++) {
			var id = this._markers[i].getPlainId();

			if (data.signId.indexOf(id) != -1) { // pokud je id oznacniku v poly
				var coords = Scene.coordsFromWGS84(this._data[i].mark.x, this._data[i].mark.y);
				var r = getSignIcon(this._data[i].typeId);
				var marker = Scene.createMarkerMapyWindy(coords, undefined, {
					type: data.highlight ? (
						this._markers[i].getType() == Scene.VISUAL.MARKER_WINDY.MIDDLE ? Scene.VISUAL.MARKER_WINDY.BIG : Scene.VISUAL.MARKER_WINDY.MIDDLE
					) : (
						this._markers[i].getType() == Scene.VISUAL.MARKER_WINDY.BIG ? Scene.VISUAL.MARKER_WINDY.MIDDLE : Scene.VISUAL.MARKER_WINDY.SMALL
					),
					icon: r.icon,
					srcset: r.srcset
				});
				marker.setPOI(Object.assign({ source: "pubt" }, this._data[i]));
				marker.setActive(this._markers[i].getActiveFlag());
				this._swapMarkers(i, marker, markers);
			}
		}

		masakovac.redraw();
	}

	_swapMarkers(i, marker, markers) {
		var masakovac = Mapy.getComponent("masakovac");
		var high = this._highlights.indexOf(this._markers[i]);
		var inc = markers.indexOf(this._markers[i]) != -1;

		if (high != -1) { this._highlights[high] = marker; }

		if (inc) {
			masakovac.removeMarker(this._markers[i], true);
			masakovac.addMarker("detail", marker, "pubt", marker.getPlainId(), true);
		}

		this._markers[i].destroy();
		this._markers[i] = marker;
	}

	_markerClick(e) {
		for (let i = 0; i < this._markers.length; i++) {
			if (this._markers[i] == e.target) {
				let poi = this._markers[i].getPOI();
				if (poi.source && poi.id) {
					let state = Mapy.getComponent("history").state;
					window.open(`${CONFIG.mapyURL}/${state.mapset}?source=${poi.source}&id=${poi.id}`);
				}

				break;
			}
		}
	}
}
